import JSEncrypt from 'jsencrypt';

const RAW_KEY = process.env.REACT_APP_RSA_PUBLIC_KEY || '';

// Wrap raw Base64 in PEM headers if not already present
function normalizePem(key: string): string {
  const stripped = key.trim();
  if (stripped.startsWith('-----BEGIN PUBLIC KEY-----')) return stripped;
  return `-----BEGIN PUBLIC KEY-----\n${stripped}\n-----END PUBLIC KEY-----`;
}

const PUBLIC_KEY = normalizePem(RAW_KEY);

// RSA/ECB/PKCS1Padding — matches Java's default RSA cipher
export function encrypt(value: string): string {
  if (!RAW_KEY) {
    throw new Error('RSA public key is not configured. Set REACT_APP_RSA_PUBLIC_KEY in your .env file.');
  }

  const rsa = new JSEncrypt();
  rsa.setPublicKey(PUBLIC_KEY);

  const encrypted = rsa.encrypt(value);
  if (!encrypted) {
    throw new Error('RSA encryption failed — check that REACT_APP_RSA_PUBLIC_KEY is a valid 2048-bit RSA public key.');
  }

  return encrypted;
}
